import React from "react";
import { createRoot } from "react-dom/client";
import { MsalProvider } from "@azure/msal-react";
import "./styles/theme.css";
import "./index.css";
import App from "./App";
import { createMsalInstance } from "./auth/msalInstance";
import { prefetchPortfolioIndex } from "./utils/portfolioData";

// Fire before MSAL init / React mount, not inside HomePage's post-mount effect — the home
// hero's data request starts the instant the bundle parses instead of waiting on the auth
// bootstrap below and a full mount+effect cycle after that.
prefetchPortfolioIndex();

const container = document.getElementById("root");
const root = createRoot(container);

async function bootstrap() {
  const msalInstance = createMsalInstance();

  if (msalInstance) {
    await msalInstance.initialize();
    try {
      await msalInstance.handleRedirectPromise();
    } catch (e) {
      console.error("MSAL redirect handling failed", e);
    }
  }

  root.render(
    msalInstance ? (
      <MsalProvider instance={msalInstance}>
        <App />
      </MsalProvider>
    ) : (
      <App />
    )
  );
}

bootstrap().catch((err) => {
  console.error("Bootstrap failed", err);
  root.render(
    <div style={{ padding: 24, fontFamily: "system-ui, sans-serif" }}>
      <h1>Application failed to start</h1>
      <p>{err instanceof Error ? err.message : String(err)}</p>
      <p style={{ color: "#555", fontSize: 14 }}>
        Check Microsoft Entra variables (<code>REACT_APP_ENTRA_*</code>) and
        reload.
      </p>
    </div>
  );
});
